export default function Col(props) {
  const { tag, onClick, onMouseEnter, onMouseLeave, style, className } = props;

  const Tag = tag || "article";

  return (
    <Tag
      style={style}
      className={`${className ? className : "element _col"}`}
      onClick={onClick ? onClick : undefined}
      onMouseEnter={onMouseEnter ?? undefined}
      onMouseLeave={onMouseLeave ?? undefined}
    >
      {props.children}
    </Tag>
  );
}
